import { useMutation } from '@tanstack/react-query'

import { lessonEntityMutations } from './lesson.mutation'

export const useLessonMutations = (bearerToken: string) => {
  const createPodoClass = useMutation({
    ...lessonEntityMutations.createClass({ bearerToken }),
  })

  return {
    createPodoClass,
  }
}
